<template>
  <div role="gridcell" :is="tag" :class="[baseCss, equalHeight ? `${baseCss}-equal-height` : '', `bcq-flex-col-${span}`]" :style="style()">
    <slot />
  </div>
</template>
<script>
import mixins from '../../mixins/methods'

export default {
  name: 'FlexCol',
  mixins: [
    mixins
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('flex-col')
    }
  },
  props: {
    equalHeight: {
      type: Boolean
    },
    tag: {
      type: String,
      default: 'section'
    },
    span: {
      type: Number,
      required: true,
      validator (value) {
        if (value > 24 || value < 1) {
          return false
        }
        return true
      }
    }
  },
  methods: {
    style () {
      return {
        padding: `${this.$parent.spacing}px` || 0
      }
    }
  }
}
</script>
<style>
.bcq-flex-col-equal-height
{
  flex: 1 0 auto;
}
.bcq-flex-col-1
{
  width: 4.166666666666667%;
  flex-basis: 4.166666666666667%;
}

.bcq-flex-col-2
{
  width: 8.333333333333334%;
  flex-basis: 8.333333333333334%;
}

.bcq-flex-col-3
{
  width: 12.5%;
  flex-basis: 12.5%;
}

.bcq-flex-col-4
{
  width: 16.666666666666668%;
  flex-basis: 16.666666666666668%;
}

.bcq-flex-col-5
{
  width: 20.833333333333336%;
  flex-basis: 20.833333333333336%;
}

.bcq-flex-col-6
{
  width: 25%;
  flex-basis: 25%;
}

.bcq-flex-col-7
{
  width: 29.166666666666668%;
  flex-basis: 29.166666666666668%;
}

.bcq-flex-col-8
{
  width: 33.333333333333336%;
  flex-basis: 33.333333333333336%;
}

.bcq-flex-col-9
{
  width: 37.5%;
  flex-basis: 37.5%;
}

.bcq-flex-col-10
{
  width: 41.66666666666667%;
  flex-basis: 41.66666666666667%;
}

.bcq-flex-col-11
{
  width: 45.833333333333336%;
  flex-basis: 45.833333333333336%;
}

.bcq-flex-col-12
{
  width: 50%;
  flex-basis: 50%;
}

.bcq-flex-col-13
{
  width: 54.16666666666667%;
  flex-basis: 54.16666666666667%;
}

.bcq-flex-col-14
{
  width: 58.333333333333336%;
  flex-basis: 58.333333333333336%;
}

.bcq-flex-col-15
{
  width: 62.50000000000001%;
  flex-basis: 62.50000000000001%;
}

.bcq-flex-col-16
{
  width: 66.66666666666667%;
  flex-basis: 66.66666666666667%;
}

.bcq-flex-col-17
{
  width: 70.83333333333334%;
  flex-basis: 70.83333333333334%;
}

.bcq-flex-col-18
{
  width: 75%;
  flex-basis: 75%;
}

.bcq-flex-col-19
{
  width: 79.16666666666667%;
  flex-basis: 79.16666666666667%;
}

.bcq-flex-col-20
{
  width: 83.33333333333334%;
  flex-basis: 83.33333333333334%;
}

.bcq-flex-col-21
{
  width: 87.5%;
  flex-basis: 87.5%;
}

.bcq-flex-col-22
{
  width: 91.66666666666667%;
  flex-basis: 91.66666666666667%;
}

.bcq-flex-col-23
{
  width: 95.83333333333334%;
  flex-basis: 95.83333333333334%;
}

.bcq-flex-col-24
{
  width: 100%;
  flex-basis: 100%;
}

@media (max-width: 1920px)
{
  .bcq-flex-col[xl24]
  {
    width: 100%;
    flex-basis: 100%;
  }

  .bcq-flex-col[xl23]
  {
    width: 95.83333333333334%;
    flex-basis: 95.83333333333334%;
  }

  .bcq-flex-col[xl22]
  {
    width: 91.66666666666667%;
    flex-basis: 91.66666666666667%;
  }

  .bcq-flex-col[xl21]
  {
    width: 87.5%;
    flex-basis: 87.5%;
  }

  .bcq-flex-col[xl20]
  {
    width: 83.33333333333334%;
    flex-basis: 83.33333333333334%;
  }

  .bcq-flex-col[xl19]
  {
    width: 79.16666666666667%;
    flex-basis: 79.16666666666667%;
  }

  .bcq-flex-col[xl18]
  {
    width: 75%;
    flex-basis: 75%;
  }

  .bcq-flex-col[xl17]
  {
    width: 70.83333333333334%;
    flex-basis: 70.83333333333334%;
  }

  .bcq-flex-col[xl16]
  {
    width: 66.66666666666667%;
    flex-basis: 66.66666666666667%;
  }

  .bcq-flex-col[xl15]
  {
    width: 62.50000000000001%;
    flex-basis: 62.50000000000001%;
  }

  .bcq-flex-col[xl14]
  {
    width: 58.333333333333336%;
    flex-basis: 58.333333333333336%;
  }

  .bcq-flex-col[xl13]
  {
    width: 54.16666666666667%;
    flex-basis: 54.16666666666667%;
  }

  .bcq-flex-col[xl12]
  {
    width: 50%;
    flex-basis: 50%;
  }

  .bcq-flex-col[xl11]
  {
    width: 45.833333333333336%;
    flex-basis: 45.833333333333336%;
  }

  .bcq-flex-col[xl10]
  {
    width: 41.66666666666667%;
    flex-basis: 41.66666666666667%;
  }

  .bcq-flex-col[xl9]
  {
    width: 37.5%;
    flex-basis: 37.5%;
  }

  .bcq-flex-col[xl8]
  {
    width: 33.333333333333336%;
    flex-basis: 33.333333333333336%;
  }

  .bcq-flex-col[xl7]
  {
    width: 29.166666666666668%;
    flex-basis: 29.166666666666668%;
  }

  .bcq-flex-col[xl6]
  {
    width: 25%;
    flex-basis: 25%;
  }

  .bcq-flex-col[xl5]
  {
    width: 20.833333333333336%;
    flex-basis: 20.833333333333336%;
  }

  .bcq-flex-col[xl4]
  {
    width: 16.666666666666668%;
    flex-basis: 16.666666666666668%;
  }

  .bcq-flex-col[xl3]
  {
    width: 12.5%;
    flex-basis: 12.5%;
  }

  .bcq-flex-col[xl2]
  {
    width: 8.333333333333334%;
    flex-basis: 8.333333333333334%;
  }

  .bcq-flex-col[xl1]
  {
    width: 4.166666666666667%;
    flex-basis: 4.166666666666667%;
  }
}

@media (max-width: 1440px)
{
  .bcq-flex-col[lg24]
  {
    width: 100%;
    flex-basis: 100%;
  }

  .bcq-flex-col[lg23]
  {
    width: 95.83333333333334%;
    flex-basis: 95.83333333333334%;
  }

  .bcq-flex-col[lg22]
  {
    width: 91.66666666666667%;
    flex-basis: 91.66666666666667%;
  }

  .bcq-flex-col[lg21]
  {
    width: 87.5%;
    flex-basis: 87.5%;
  }

  .bcq-flex-col[lg20]
  {
    width: 83.33333333333334%;
    flex-basis: 83.33333333333334%;
  }

  .bcq-flex-col[lg19]
  {
    width: 79.16666666666667%;
    flex-basis: 79.16666666666667%;
  }

  .bcq-flex-col[lg18]
  {
    width: 75%;
    flex-basis: 75%;
  }

  .bcq-flex-col[lg17]
  {
    width: 70.83333333333334%;
    flex-basis: 70.83333333333334%;
  }

  .bcq-flex-col[lg16]
  {
    width: 66.66666666666667%;
    flex-basis: 66.66666666666667%;
  }

  .bcq-flex-col[lg15]
  {
    width: 62.50000000000001%;
    flex-basis: 62.50000000000001%;
  }

  .bcq-flex-col[lg14]
  {
    width: 58.333333333333336%;
    flex-basis: 58.333333333333336%;
  }

  .bcq-flex-col[lg13]
  {
    width: 54.16666666666667%;
    flex-basis: 54.16666666666667%;
  }

  .bcq-flex-col[lg12]
  {
    width: 50%;
    flex-basis: 50%;
  }

  .bcq-flex-col[lg11]
  {
    width: 45.833333333333336%;
    flex-basis: 45.833333333333336%;
  }

  .bcq-flex-col[lg10]
  {
    width: 41.66666666666667%;
    flex-basis: 41.66666666666667%;
  }

  .bcq-flex-col[lg9]
  {
    width: 37.5%;
    flex-basis: 37.5%;
  }

  .bcq-flex-col[lg8]
  {
    width: 33.333333333333336%;
    flex-basis: 33.333333333333336%;
  }

  .bcq-flex-col[lg7]
  {
    width: 29.166666666666668%;
    flex-basis: 29.166666666666668%;
  }

  .bcq-flex-col[lg6]
  {
    width: 25%;
    flex-basis: 25%;
  }

  .bcq-flex-col[lg5]
  {
    width: 20.833333333333336%;
    flex-basis: 20.833333333333336%;
  }

  .bcq-flex-col[lg4]
  {
    width: 16.666666666666668%;
    flex-basis: 16.666666666666668%;
  }

  .bcq-flex-col[lg3]
  {
    width: 12.5%;
    flex-basis: 12.5%;
  }

  .bcq-flex-col[lg2]
  {
    width: 8.333333333333334%;
    flex-basis: 8.333333333333334%;
  }

  .bcq-flex-col[lg1]
  {
    width: 4.166666666666667%;
    flex-basis: 4.166666666666667%;
  }
}

@media (max-width: 1024px)
{
  .bcq-flex-col[md24]
  {
    width: 100%;
    flex-basis: 100%;
  }

  .bcq-flex-col[md23]
  {
    width: 95.83333333333334%;
    flex-basis: 95.83333333333334%;
  }

  .bcq-flex-col[md22]
  {
    width: 91.66666666666667%;
    flex-basis: 91.66666666666667%;
  }

  .bcq-flex-col[md21]
  {
    width: 87.5%;
    flex-basis: 87.5%;
  }

  .bcq-flex-col[md20]
  {
    width: 83.33333333333334%;
    flex-basis: 83.33333333333334%;
  }

  .bcq-flex-col[md19]
  {
    width: 79.16666666666667%;
    flex-basis: 79.16666666666667%;
  }

  .bcq-flex-col[md18]
  {
    width: 75%;
    flex-basis: 75%;
  }

  .bcq-flex-col[md17]
  {
    width: 70.83333333333334%;
    flex-basis: 70.83333333333334%;
  }

  .bcq-flex-col[md16]
  {
    width: 66.66666666666667%;
    flex-basis: 66.66666666666667%;
  }

  .bcq-flex-col[md15]
  {
    width: 62.50000000000001%;
    flex-basis: 62.50000000000001%;
  }

  .bcq-flex-col[md14]
  {
    width: 58.333333333333336%;
    flex-basis: 58.333333333333336%;
  }

  .bcq-flex-col[md13]
  {
    width: 54.16666666666667%;
    flex-basis: 54.16666666666667%;
  }

  .bcq-flex-col[md12]
  {
    width: 50%;
    flex-basis: 50%;
  }

  .bcq-flex-col[md11]
  {
    width: 45.833333333333336%;
    flex-basis: 45.833333333333336%;
  }

  .bcq-flex-col[md10]
  {
    width: 41.66666666666667%;
    flex-basis: 41.66666666666667%;
  }

  .bcq-flex-col[md9]
  {
    width: 37.5%;
    flex-basis: 37.5%;
  }

  .bcq-flex-col[md8]
  {
    width: 33.333333333333336%;
    flex-basis: 33.333333333333336%;
  }

  .bcq-flex-col[md7]
  {
    width: 29.166666666666668%;
    flex-basis: 29.166666666666668%;
  }

  .bcq-flex-col[md6]
  {
    width: 25%;
    flex-basis: 25%;
  }

  .bcq-flex-col[md5]
  {
    width: 20.833333333333336%;
    flex-basis: 20.833333333333336%;
  }

  .bcq-flex-col[md4]
  {
    width: 16.666666666666668%;
    flex-basis: 16.666666666666668%;
  }

  .bcq-flex-col[md3]
  {
    width: 12.5%;
    flex-basis: 12.5%;
  }

  .bcq-flex-col[md2]
  {
    width: 8.333333333333334%;
    flex-basis: 8.333333333333334%;
  }

  .bcq-flex-col[md1]
  {
    width: 4.166666666666667%;
    flex-basis: 4.166666666666667%;
  }
}

@media (max-width: 960px)
{
  .bcq-flex-col[sm24]
  {
    width: 100%;
    flex-basis: 100%;
  }

  .bcq-flex-col[sm23]
  {
    width: 95.83333333333334%;
    flex-basis: 95.83333333333334%;
  }

  .bcq-flex-col[sm22]
  {
    width: 91.66666666666667%;
    flex-basis: 91.66666666666667%;
  }

  .bcq-flex-col[sm21]
  {
    width: 87.5%;
    flex-basis: 87.5%;
  }

  .bcq-flex-col[sm20]
  {
    width: 83.33333333333334%;
    flex-basis: 83.33333333333334%;
  }

  .bcq-flex-col[sm19]
  {
    width: 79.16666666666667%;
    flex-basis: 79.16666666666667%;
  }

  .bcq-flex-col[sm18]
  {
    width: 75%;
    flex-basis: 75%;
  }

  .bcq-flex-col[sm17]
  {
    width: 70.83333333333334%;
    flex-basis: 70.83333333333334%;
  }

  .bcq-flex-col[sm16]
  {
    width: 66.66666666666667%;
    flex-basis: 66.66666666666667%;
  }

  .bcq-flex-col[sm15]
  {
    width: 62.50000000000001%;
    flex-basis: 62.50000000000001%;
  }

  .bcq-flex-col[sm14]
  {
    width: 58.333333333333336%;
    flex-basis: 58.333333333333336%;
  }

  .bcq-flex-col[sm13]
  {
    width: 54.16666666666667%;
    flex-basis: 54.16666666666667%;
  }

  .bcq-flex-col[sm12]
  {
    width: 50%;
    flex-basis: 50%;
  }

  .bcq-flex-col[sm11]
  {
    width: 45.833333333333336%;
    flex-basis: 45.833333333333336%;
  }

  .bcq-flex-col[sm10]
  {
    width: 41.66666666666667%;
    flex-basis: 41.66666666666667%;
  }

  .bcq-flex-col[sm9]
  {
    width: 37.5%;
    flex-basis: 37.5%;
  }

  .bcq-flex-col[sm8]
  {
    width: 33.333333333333336%;
    flex-basis: 33.333333333333336%;
  }

  .bcq-flex-col[sm7]
  {
    width: 29.166666666666668%;
    flex-basis: 29.166666666666668%;
  }

  .bcq-flex-col[sm6]
  {
    width: 25%;
    flex-basis: 25%;
  }

  .bcq-flex-col[sm5]
  {
    width: 20.833333333333336%;
    flex-basis: 20.833333333333336%;
  }

  .bcq-flex-col[sm4]
  {
    width: 16.666666666666668%;
    flex-basis: 16.666666666666668%;
  }

  .bcq-flex-col[sm3]
  {
    width: 12.5%;
    flex-basis: 12.5%;
  }

  .bcq-flex-col[sm2]
  {
    width: 8.333333333333334%;
    flex-basis: 8.333333333333334%;
  }

  .bcq-flex-col[sm1]
  {
    width: 4.166666666666667%;
    flex-basis: 4.166666666666667%;
  }
}

@media (max-width: 480px)
{
  .bcq-flex-col[xs24]
  {
    width: 100%;
    flex-basis: 100%;
  }

  .bcq-flex-col[xs23]
  {
    width: 95.83333333333334%;
    flex-basis: 95.83333333333334%;
  }

  .bcq-flex-col[xs22]
  {
    width: 91.66666666666667%;
    flex-basis: 91.66666666666667%;
  }

  .bcq-flex-col[xs21]
  {
    width: 87.5%;
    flex-basis: 87.5%;
  }

  .bcq-flex-col[xs20]
  {
    width: 83.33333333333334%;
    flex-basis: 83.33333333333334%;
  }

  .bcq-flex-col[xs19]
  {
    width: 79.16666666666667%;
    flex-basis: 79.16666666666667%;
  }

  .bcq-flex-col[xs18]
  {
    width: 75%;
    flex-basis: 75%;
  }

  .bcq-flex-col[xs17]
  {
    width: 70.83333333333334%;
    flex-basis: 70.83333333333334%;
  }

  .bcq-flex-col[xs16]
  {
    width: 66.66666666666667%;
    flex-basis: 66.66666666666667%;
  }

  .bcq-flex-col[xs15]
  {
    width: 62.50000000000001%;
    flex-basis: 62.50000000000001%;
  }

  .bcq-flex-col[xs14]
  {
    width: 58.333333333333336%;
    flex-basis: 58.333333333333336%;
  }

  .bcq-flex-col[xs13]
  {
    width: 54.16666666666667%;
    flex-basis: 54.16666666666667%;
  }

  .bcq-flex-col[xs12]
  {
    width: 50%;
    flex-basis: 50%;
  }

  .bcq-flex-col[xs11]
  {
    width: 45.833333333333336%;
    flex-basis: 45.833333333333336%;
  }

  .bcq-flex-col[xs10]
  {
    width: 41.66666666666667%;
    flex-basis: 41.66666666666667%;
  }

  .bcq-flex-col[xs9]
  {
    width: 37.5%;
    flex-basis: 37.5%;
  }

  .bcq-flex-col[xs8]
  {
    width: 33.333333333333336%;
    flex-basis: 33.333333333333336%;
  }

  .bcq-flex-col[xs7]
  {
    width: 29.166666666666668%;
    flex-basis: 29.166666666666668%;
  }

  .bcq-flex-col[xs6]
  {
    width: 25%;
    flex-basis: 25%;
  }

  .bcq-flex-col[xs5]
  {
    width: 20.833333333333336%;
    flex-basis: 20.833333333333336%;
  }

  .bcq-flex-col[xs4]
  {
    width: 16.666666666666668%;
    flex-basis: 16.666666666666668%;
  }

  .bcq-flex-col[xs3]
  {
    width: 12.5%;
    flex-basis: 12.5%;
  }

  .bcq-flex-col[xs2]
  {
    width: 8.333333333333334%;
    flex-basis: 8.333333333333334%;
  }

  .bcq-flex-col[xs1]
  {
    width: 4.166666666666667%;
    flex-basis: 4.166666666666667%;
  }
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/flex-col/flex-col.vue